import React, { useState, useEffect, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import api from '../../api/api.js';
import { API_BASE_URL } from '../../config';
import { Bell, Heart, Home, MessageSquare, Plus, Search, Star, Wrench, Eye } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar"; // Kept for now, might be unused by NavbarLogout
import { Badge } from "../../_newprofiles/components/ui/Badge";
import { Button } from "../../_newprofiles/components/ui/Button"; // Kept for now
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card";
import styles from "./_HomeUserDashboard.module.css";
import SearchFormComponent from "./SearchFormComponent";
import ProjectsWidget from "./components/ProjectsWidget"; // Import the new component
import FeaturedBusinesses from "./_FeaturedBusinesses"; // Import the new component
import NavbarLogout from "../../components/Navbar/navbar-logout";
import { jwtDecode } from 'jwt-decode';
import {  useNavigate } from 'react-router-dom';
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";
import BusinessProfilePureCSS from '../../profiles/BusinessProfilePureCSS';
import JobCreationAssistant from './JobCreationAssistant'; // 



const HomeUserDashboardPureCSS = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [activeJobsData, setActiveJobsData] = useState([]);
  const [isLoadingActiveJobs, setIsLoadingActiveJobs] = useState(false);
  const [activeJobsError, setActiveJobsError] = useState(null);
  const [homeUserId, setHomeUserId] = useState(null);

  // State for Saved Businesses
  const [savedBusinessesData, setSavedBusinessesData] = useState([]);
  const [isLoadingSavedBusinesses, setIsLoadingSavedBusinesses] = useState(false);
  const [savedBusinessesError, setSavedBusinessesError] = useState(null);

  // State for Completed Jobs Count
  const [completedJobsCount, setCompletedJobsCount] = useState(0);
  const [isLoadingCompletedJobs, setIsLoadingCompletedJobs] = useState(false);
  const [completedJobsError, setCompletedJobsError] = useState(null);

  // State for Conversation Count
  const [conversationCount, setConversationCount] = useState(0);
  const [isLoadingConversationCount, setIsLoadingConversationCount] = useState(false);
  const [conversationCountError, setConversationCountError] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state for message button

    const [recentMessages, setRecentMessages] = useState([]);
    const [isLoadingMessages, setIsLoadingMessages] = useState(false);
    const [messagesError, setMessagesError] = useState(null);
    const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);

      // --- STATE FOR IMAGE MODAL 
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [jobImages, setJobImages] = useState([]);

    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);


    // --- MODIFICATION 2: ADD STATE AND HANDLERS FOR THE PANEL ---
    const [isBusinessProfileOpen, setIsBusinessProfileOpen] = useState(false);
    const [selectedBusinessId, setSelectedBusinessId] = useState(null);

    const openBusinessProfile = (businessId) => {
        setSelectedBusinessId(businessId);
        setIsBusinessProfileOpen(true);
    };

    const closeBusinessProfile = () => {
        setIsBusinessProfileOpen(false);
        setSelectedBusinessId(null);
    };


  const handleResize = useCallback(() => {
    setIsMobileView(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  
  // --- MODIFICATION: FUNCTIONS FOR IMAGE MODAL (Already exists, just confirm) ---
  const openImageModal = (images, index) => {
    setJobImages(images.filter(img => img)); // Filter out null/empty images
    setSelectedImageIndex(index);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  const nextImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex + 1) % jobImages.length);
  };

  const prevImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex - 1 + jobImages.length) % jobImages.length);
  };


  useEffect(() => {

    //check to see if the user type is Home or business
    // if home , forward to / 
    // if business /newbusiness

    const myuserType = localStorage.getItem('userType');

    //navigate('/newhome');



    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUsername(decodedToken.UserName || 'User');
        setHomeUserId(decodedToken.nameid); // Set homeUserId here
      } catch (error) {
        console.error("Error decoding token:", error);
        setUsername('User');
        setActiveJobsError("Failed to identify user.");
      }
    } else {
      setUsername('User');
      setActiveJobsError("No user token found. Please log in.");
    }
  }, []);

  useEffect(() => {
    if (homeUserId) {
      const fetchActiveJobs = async () => {
        setIsLoadingActiveJobs(true);
        setActiveJobsError(null);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/Jobs/getmyactivejobs?homeUserId=${homeUserId}`
          );
          setActiveJobsData(response.data || []);
        } catch (err) {
          if (err.response && err.response.status === 404) {
            // The API returns a direct string message for 404, not JSON
            const errorMessage = err.response.data || "No active jobs found for your profile.";
            console.log(errorMessage); // Log the specific message from the server
            setActiveJobsError(errorMessage);
          } else {
            console.error("Error fetching active jobs:", err);
            setActiveJobsError(err.message || "An unexpected error occurred while fetching active jobs.");
          }
          setActiveJobsData([]);
        } finally {
          setIsLoadingActiveJobs(false);
        }
      };
      fetchActiveJobs();
    } else if (!localStorage.getItem('token')) { // Check token again to avoid race condition if homeUserId isn't set yet
        setActiveJobsData([]);
        setIsLoadingActiveJobs(false);
    }

    // Fetch Saved Businesses
    if (homeUserId) {
      const fetchSavedBusinesses = async () => {
        setIsLoadingSavedBusinesses(true);
        setSavedBusinessesError(null);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/BusinessProfile/getSavedBusinesses?userType=Home&userId=${homeUserId}`
          );
          setSavedBusinessesData(response.data || []);
        } catch (err) {
          console.error("Error fetching saved businesses:", err);
          setSavedBusinessesError(err.message || "Failed to fetch saved businesses.");
          setSavedBusinessesData([]);
        } finally {
          setIsLoadingSavedBusinesses(false);
        }
      };
      fetchSavedBusinesses();
    } else if (!localStorage.getItem('token')) {
        setSavedBusinessesData([]);
        setIsLoadingSavedBusinesses(false);
    }

    // Fetch Completed Jobs Count
    if (homeUserId) {
      const fetchCompletedJobsCount = async () => {
        setIsLoadingCompletedJobs(true);
        setCompletedJobsError(null);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/Jobs/getmycompletedjobcount?homeUserId=${homeUserId}`
          );
          setCompletedJobsCount(response.data || 0);
        } catch (err) {
          console.error("Error fetching completed jobs count:", err);
          setCompletedJobsError(err.message || "Failed to fetch count.");
          setCompletedJobsCount(0);
        } finally {
          setIsLoadingCompletedJobs(false);
        }
      };
      fetchCompletedJobsCount();
    } else if (!localStorage.getItem('token')) {
        setCompletedJobsCount(0);
        setIsLoadingCompletedJobs(false);
    }

    // Fetch Conversation Count
    if (homeUserId) {
      const fetchConversationCount = async () => {
        setIsLoadingConversationCount(true);
        setConversationCountError(null);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/Chat/homeUserConversationCount?homeUserId=${homeUserId}`
          );
          setConversationCount(response.data || 0);
        } catch (err) {
          console.error("Error fetching conversation count:", err);
          setConversationCountError(err.message || "Failed to fetch count.");
          setConversationCount(0);
        } finally {
          setIsLoadingConversationCount(false);
        }
      };
      fetchConversationCount();
    } else if (!localStorage.getItem('token')) {
      setConversationCount(0);
      setIsLoadingConversationCount(false);
    }
  }, [homeUserId]); // Depend on homeUserId

  const getFirstName = (name) => {
    if (!name || name.toLowerCase() === 'user') return 'User';
    return name.split(' ')[0];
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Complete": return styles.jobItem_statusCompleted;
      case "In Progress": case "Assigned": return styles.jobItem_statusAssigned;
      case "Open": return styles.jobItem_statusOpen;
      case "Pending": return styles.jobItem_statusPending;
      default: return styles.jobItem_statusDefault;
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Complete": return "✅";
      case "In Progress": case "Assigned": case "Open": return "🛠️";
      case "Pending": return "⏳";
      default: return "📄";
    }
  };

  // Removed static savedBusinesses array, will use savedBusinessesData from state

  const handleMessageClick = async (e, otherUser) => {
    setLoading(true);
    try {

        console.log(`otherUser.businessId = ${otherUser.businessId}`);
        console.log(`otherUser.businessUserId = ${otherUser.businessUserId}`);


        // 1. Grab your auth token, decode it:
        const token = localStorage.getItem('token');
        if (!token) {
        navigate('/login');
        return;
        }
        const { nameid: currentUserId, UserType } = jwtDecode(token);

        

        // 2. Build the three query params that NewConversation expects:
        //    - always need senderBusinessUserId
        //    - supply either homeUserId OR receiverBusinessUserId
        const isHome = UserType == 'Home';

        const senderBusinessUserId = isHome
        ? otherUser.businessUserId    // if I'm a Home‐user, I pass the Business I'm talking to
        : currentUserId;              // otherwise I (a Business) pass my own ID

        const homeUserId = isHome
        ? currentUserId               // Home user passes themselves
        : undefined;

        const receiverBusinessUserId = otherUser.businessUserId;


        console.log(`currentUserId = ${currentUserId}`);
        console.log(`senderBusinessUserId = ${senderBusinessUserId}`);
        console.log(`receiverBusinessUserId = ${receiverBusinessUserId}`);
        console.log(`homeUserId = ${homeUserId}`);


        // 3. Assemble and call the NewConversation endpoint:
        const params = new URLSearchParams({
        senderBusinessUserId: String(senderBusinessUserId),
        ...(homeUserId != null && { homeUserId: String(homeUserId) }),
        ...(receiverBusinessUserId != null && {
            receiverBusinessUserId: String(receiverBusinessUserId),
        }),
        });
        const { data } = await axios.get(
        `${API_BASE_URL}/api/Chat/NewConversation?${params.toString()}`
        );

        // 4. Pull out the conversationId and open the right route in a new tab
        const { conversationId } = data;
        const path = isHome
        ? `/home_messages?conversationId=${conversationId}`
        : `/business_messages?conversationId=${conversationId}`;

        window.open(path, '_blank', 'noopener,noreferrer');
    } catch (err) {
        console.error('Error starting conversation:', err);
    } finally {
        setLoading(false);
    }
  };

 



    // --- USEEFFECT TO FETCH MESSAGES ---
    useEffect(() => {
        const fetchRecentMessages = async () => {
            setIsLoadingMessages(true);
            setMessagesError(null);
            try {
                // Use your configured 'api' instance which includes the auth token
                const response = await api.get('/api/Chat/getRecentMessages');
                setRecentMessages(response.data || []); // The backend returns data directly on the api instance
            } catch (err) {
                console.error("Error fetching recent messages:", err);
                setMessagesError("Failed to load messages.");
                setRecentMessages([]);
            } finally {
                setIsLoadingMessages(false);
            }
        };

        if (homeUserId) { 
            fetchRecentMessages();
        }

    }, [homeUserId]);


  // --- HELPER FUNCTION ---
  const timeSince = (date) => {
      const seconds = Math.floor((new Date() - new Date(date)) / 1000);
      let interval = seconds / 31536000;
      if (interval > 1) return Math.floor(interval) + " years ago";
      interval = seconds / 2592000;
      if (interval > 1) return Math.floor(interval) + " months ago";
      interval = seconds / 86400;
      if (interval > 1) return Math.floor(interval) + " days ago";
      interval = seconds / 3600;
      if (interval > 1) return Math.floor(interval) + " hours ago";
      interval = seconds / 60;
      if (interval > 1) return Math.floor(interval) + " minutes ago";
      return "Just now";
  };



  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            <div className={styles.headerLeft}>
              <div className={styles.logoContainer}>
                <Home className={styles.logoIcon} />
                <span className={styles.logoText}>Build Start</span>
              </div>
              <Badge variant="secondary" className={styles.homeOwnerBadge}>Homeowner</Badge>
            </div>
           <ModernNavbarPureCSS UserName={username} prefix={''} />

          </div>
        </div>
      </header>

      <div className={styles.container}>
        <div className={styles.mainContent}>
            <div className={styles.welcomeSection}>
              <h1 className={styles.welcomeTitle}>Welcome home, {getFirstName(username)}! 🏠</h1>
              <p className={styles.welcomeSubtitle}>Manage your home improvement projects and connect with trusted professionals</p>
            </div>

            <div className={styles.quickSearchCardWrapper}>
              <SearchFormComponent />
            </div>

            <div className={styles.statsGrid}>
              <Card className={`${styles.statCard} ${styles.statCardBlue}`}>
                  <CardContent className={styles.statCardContent}>
                  <div className={styles.statCardInfo}>
                      <div>
                      <p className={styles.statLabelBlue}>Active Jobs</p>
                      {/* This will now be dynamic based on fetched data length if preferred */}
                      <p className={styles.statValue}>{isLoadingActiveJobs ? '...' : activeJobsData.length}</p>
                      {/* <p className={styles.statChangeBlue}>1 starting soon</p> */}
                      </div>
                      <Wrench className={styles.statIconBlue} />
                  </div>
                  </CardContent>
              </Card>

              {/* Other stats cards remain the same */}
              <Card className={`${styles.statCard} ${styles.statCardAmber}`}>
                <CardContent className={styles.statCardContent}>
                <div className={styles.statCardInfo}>
                    <div>
                    <p className={styles.statLabelAmber}>Saved Businesses</p>
                    <p className={styles.statValue}>{isLoadingSavedBusinesses ? '...' : savedBusinessesData.length}</p>
                    <p className={styles.statChangeAmber}>&nbsp;</p>
                    </div>
                    <Heart className={styles.statIconAmber} />
                </div>
                </CardContent>
              </Card>
              <Card className={`${styles.statCard} ${styles.statCardGreen}`}>
                  <CardContent className={styles.statCardContent}>
                  <div className={styles.statCardInfo}>
                      <div>
                      <p className={styles.statLabelGreen}>Conversations</p>
                      <p className={styles.statValue}>{isLoadingConversationCount ? '...' : conversationCount}</p>
                      <p className={styles.statChangeGreen}>&nbsp;</p>
                      </div>
                      <MessageSquare className={styles.statIconGreen} />
                  </div>
                  </CardContent>
              </Card>
              <Card className={`${styles.statCard} ${styles.statCardPurple}`}>
                  <CardContent className={styles.statCardContent}>
                  <div className={styles.statCardInfo}>
                      <div>
                      <p className={styles.statLabelPurple}>Completed Jobs</p>
                      <p className={styles.statValue}>{isLoadingCompletedJobs ? '...' : completedJobsCount}</p>
                      <p className={styles.statChangePurple}>&nbsp;</p>
                      </div>
                      <Star className={styles.statIconPurple} />
                  </div>
                  </CardContent>
              </Card>
            </div>

            <div className={styles.mainLayoutGrid}>
              <div className={`${styles.leftColumn} ${styles.spaceY6}`}>

                <ProjectsWidget homeUserId={homeUserId} />

                <Card className={styles.cardBase}>
                  <CardHeader>
                      <div className={styles.projectsHeader}>
                      <CardTitle className={styles.cardTitleContainer}>
                          <Wrench className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                          <span>Active Jobs</span>
                      </CardTitle>
                      {/* Optional: Link to a full jobs page */}
                      {/* <NavLink to="/jobsdashboard" className={`${styles.viewAllButtonSmall} ${styles.jobItem_buttonOutline}`}>View All Jobs</NavLink> */}
                      </div>
                  </CardHeader>

                  <CardContent>
                      {isLoadingActiveJobs && <p>Loading active projects...</p> /* Or <Loader2 /> */}
                      {!isLoadingActiveJobs && activeJobsError && <p className={styles.jobItem_errorText}> {activeJobsError}</p>}
                      {!isLoadingActiveJobs && !activeJobsError && activeJobsData.length === 0 && (
                          <p>No active projects found.</p>
                      )}
                      {!isLoadingActiveJobs && !activeJobsError && activeJobsData.length > 0 && (
                          <div className={styles.spaceY4}>
                              {activeJobsData.map((job) => (
                                  <div key={job.job_id} className={`${styles.projectItem} ${styles.jobItemGrid}`}>
                                      <div className={styles.jobItemContent}>
                                          <div className={styles.projectMeta}>
                                              <h4 className={styles.projectTitle}>{job.name}</h4>
                                              <Badge className={`${styles.jobItem_badge} ${getStatusColor(job.jobStatus)}`}>
                                                  {getStatusIcon(job.jobStatus)}
                                                  <span>{job.jobStatus}</span>
                                              </Badge>
                                          </div>
                                          <p className={styles.jobItem_description}>{job.description}</p>
                                          
{job.businessName && (
    <div className={styles.assignedBadge}>
        <Wrench className={styles.assignedBadgeIcon} size={14} />
        <span>Assigned to: {job.businessName}</span>
    </div>
)}

                                          <div className={styles.jobItem_detailsGrid}>
                                              <div>
                                                  <p className={styles.jobItem_detailLabel}>Budget:</p>
                                                  <p className={`${styles.jobItem_detailValue} ${styles.jobItem_budgetValue}`}>{job.budgetAmount ? `$${job.budgetAmount}` : (job.budget || "N/A")}</p>
                                              </div>
                                              <div>
                                                  <p className={styles.jobItem_detailLabel}>Deadline:</p>
                                                  <p className={styles.jobItem_detailValue}>{job.deadline || "N/A"}</p>
                                              </div>
                                              <div>
                                                  <p className={styles.jobItem_detailLabel}>Category:</p>
                                                  <Badge className={`${styles.jobItem_badge} ${styles.jobItem_badgeOutline}`}>
                                                      {(job.profession && job.profession.length > 0 ? job.profession[0].name : "General")}
                                                  </Badge>
                                              </div>
                                              <div>
                                                  <p className={styles.jobItem_detailLabel}>Posted:</p>
                                                  <p className={styles.jobItem_detailValue}>{job.created_at ? new Date(job.created_at).toLocaleDateString() : "N/A"}</p>
                                              </div>
                                          </div>


<div className={styles.jobItem_stats}>
    {/* Use a ternary operator to apply the correct class based on quoteCount */}
    <div className={job.quoteCount > 0 ? styles.quoteHighlightBadge : styles.jobItem_statItem}>
        <MessageSquare size={16} /> 
        <span>{job.quoteCount} {job.quoteCount === 1 ? 'quote' : 'quotes'}</span>
    </div>
</div>


                                      </div>
                                      
                                      <div className={styles.jobItemActions}>
                                          
                                          
                                          <button
                                            onClick={() => {
                                              console.log("Navigating with job:", job);
                                              navigate(`/project/${job.projectId}/${job.job_id}`);
                                            }}
                                            className={styles.jobItem_viewProfileButton}
                                          >
                                            View Details
                                          </button>


                                          {job.jobStatus === "Assigned" && job.businessName && (
                                            <button 
                                              className={styles.jobItem_viewProfileButton}
                                              onClick={(e) => handleMessageClick(e, { businessId: job.assignedBusinessId, businessUserId: job.businessUserId })}
                                              disabled={loading}
                                            >
                                              Message Business
                                            </button>
                                          )}
                                      </div>
                                  </div>
                              ))}
                          </div>
                      )}
                  </CardContent>
                </Card>
              </div>



              {/* Right Column remains the same */}
              
              <div className={`${styles.rightColumn} ${styles.spaceY6}`}>
                <FeaturedBusinesses onViewProfile={openBusinessProfile} />
              




            {/* Recent Messages */}
            <Card className={styles.cardBase}>
                <CardHeader>
                    <div className={styles.messagesHeader}>
                        <CardTitle className={styles.cardTitleContainer}>
                            <MessageSquare className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                            <span>Recent Messages</span>
                        </CardTitle>
                        {/* Optional: Calculate unread count dynamically */}
                        {recentMessages.filter(m => m.isRead).length > 0 && (
                            <Badge variant="secondary" className={styles.unreadBadge}>
                                {recentMessages.filter(m => m.isRead).length} unread
                            </Badge>
                        )}
                    </div>
                </CardHeader>

                {/* --- REPLACE THE CARDCONTENT WITH THIS --- */}
                <CardContent>
                    {isLoadingMessages && <p>Loading messages...</p>}
                    {messagesError && <p className={styles.jobItem_errorText}>{messagesError}</p>}
                    
                    {!isLoadingMessages && !messagesError && recentMessages.length === 0 && (
                        <div className={styles.emptyState}>
                            <MessageSquare size={32} className={styles.emptyStateIcon} />
                            <p className={styles.emptyStateText}>Your recent conversations will appear here.</p>
                        </div>
                    )}

                    {!isLoadingMessages && !messagesError && recentMessages.length > 0 && (
                        <div className={styles.messagesList}>
                            {recentMessages.map((message) => (
                                <div
                                    key={message.conversationId}
                                    className={`${styles.messageItem} ${message.isRead ? styles.messageItemUnread : styles.messageItemRead}`}
                                    onClick={() => navigate(`/home_messages?conversationId=${message.conversationId}`)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className={styles.messageMeta}>
                                        <span className={styles.messageClient}>{message.otherPartyName}</span>
                                        <span className={styles.messageTime}>{timeSince(message.lastMessageTimestamp)}</span>
                                    </div>
                                    <p className={styles.messagePreview}>{message.lastMessageSnippet}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    <Button 
                        variant="outline" 
                        size="sm" 
                        className={styles.viewAllSavedButton}
                        onClick={() => navigate('/home_messages')} // Navigate to the main messages page
                    >
                        View All Messages
                    </Button>
                </CardContent>
            </Card>







                  <Card className={styles.cardBase}>
                    <CardHeader>
                        <CardTitle className={styles.cardTitleContainer}>
                        <Heart className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                        <span>Saved Businesses</span>
                        </CardTitle>
                    </CardHeader>
                <CardContent>
                    {isLoadingSavedBusinesses && <p>Loading saved businesses...</p>}
                    {!isLoadingSavedBusinesses && savedBusinessesError && <p className={styles.jobItem_errorText}>Error: {savedBusinessesError}</p>}
                    {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.length === 0 && (
                        <p>No saved businesses found.</p>
                    )}
                    {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.length > 0 && (
                        <div className={styles.spaceY3}>
                            {savedBusinessesData.map((business) => (
                                <div
                                key={business.businessId} // Use businessId from API
                                className={styles.savedBusinessItem}
                                >
                                <Avatar className={styles.savedBusinessAvatar}>
                                    <AvatarImage src={business.profilePic || "/placeholder.svg"} /> 
                                   {/* Use business.profilePic, fallback to placeholder */}
                                    {/* <AvatarFallback>{business.businessName ? business.businessName.charAt(0) : "B"}</AvatarFallback> */}
                                </Avatar>
                                <div className={styles.savedBusinessInfo}>
                                    <h4 className={styles.savedBusinessName}>{business.businessName}</h4>
                                    {/* Placeholder for professions/specialty if data becomes available */}
                                    {/* <p className={styles.savedBusinessSpecialty}>{business.specialty || 'Specialty not available'}</p> */}
                                    {business.description && (
                                      <p className={styles.savedBusinessDescription}>{business.description}</p>
                                    )}
                                    <div className={styles.ratingContainer}>
                                      <Star className={styles.ratingStarIcon} />
                                      <span className={styles.ratingValue}>{business.overallRating !== null ? business.overallRating.toFixed(1) : 'N/A'}</span>
                                      {/* Number of reviews not in API, so omitted for now */}
                                      {/* <span className={styles.ratingReviews}>({business.reviews || 0} reviews)</span> */}
                                    </div>
                                </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <NavLink to="/saved-businesses" className={styles.viewAllSavedButton}>
                        <Button variant="outline" size="sm" className={styles.viewAllSavedButton}>
                            View All Saved
                        </Button>
                    </NavLink>
                </CardContent>
                
                </Card>



                  <Card className={styles.mascotCard}>
                    <CardContent className={styles.mascotContent}>
                        <div className={styles.mascotEmoji}>🏠</div>
                        <h3 className={styles.mascotTitle}>Your Dream Home Awaits!</h3>
                        <p className={styles.mascotText}>
                        Connect with trusted professionals and bring your vision to life.
                        </p>
                        <Button className={styles.mascotButton} onClick={() => navigate('/newhomejobs')}>Start Your Project</Button>
                    </CardContent>
                  </Card>
              </div>
            </div>
        </div>
      </div>



            {/* --- MODIFICATION 4: RENDER THE PANEL AT THE END --- */}
            <BusinessProfilePureCSS
                isOpen={isBusinessProfileOpen}
                onClose={closeBusinessProfile}
                businessId={selectedBusinessId}
                useIDTYPE={"BID"}
            />


            {/* --- NEW VOICE ASSISTANT --- */}
            <JobCreationAssistant homeUserId={homeUserId} />

    </div>
  );
};

export default HomeUserDashboardPureCSS;
